import React, {useState, useEffect} from 'react';
import FlightCalculator from "../../common/components/offset/FlightCalculatorV2";
import Projects from "../../common/components/offset/Projects";
import ccLogo from "../../common/media/cc_logo_color.svg";
import ccTrustPilot from "../../common/media/cc-trust-pilot.svg";
import {
    trackAdditionalPageView
} from "../../common/util/ccAnalyticsV2";


const OffsetPage = ({ merchantCode, projects}) => {

    useEffect(() => {
            //trackAdditionalPageView('/offset')
    }, []
    );

    return (
        <div className='font-etihad-important'>
            <div className="bg-white mobile-p-0 pb-5" style={{backgroundRepeat: "no-repeat", backgroundPosition: "left"}}>
                <div className="container mobile-p-0 bg-white">
                    <img src="https://res.cloudinary.com/carbonclick/image/upload/v1628976098/Enterprise/Etihad/EtihadLogo_bkjgkb.svg" />
                </div>
                <div className="container mobile-p-0">
                    <div className="center shadow-lg flight-calculator-wrapper">
                        <FlightCalculator merchantCode={merchantCode} />
                    </div>
                </div>
            </div>


            {/* <div className="bg-light img-cover pattern-3 py-4 mb-3 flight-impact">
                <div className="container">
                    <FlightImpact merchantCode={merchantCode} />
                </div>
            </div> */}

            {projects?.length > 0 && <Projects projects={[]} />}

            <div className="bg-light p-3 text-right">
                <div className="d-flex w-fit right">
                    <h5 className="margin-inline-end-2 font-bold mt-1 mb-0">Powered By</h5>
                    <div>
                        <a target="_blank" href="https://www.carbonclick.com/">
                            <img style={{ height: 24 }} src={`https://res.cloudinary.com/carbonclick/image/upload/v1699633157/Merchant%20Portal/logo_main_hwvkqk.svg`} />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OffsetPage;